export default "__VITE_ASSET__Cq1qLFh2__"